import React from 'react';
import PropTypes from 'prop-types';

import { Field, Fields } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import IconCross from 'components/icons/IconCross';
import IconButton from 'components/common/IconButton';
import UploadField from 'components/fields/UploadField';
import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';

import {
  requestSearchDocumentCategories, requestFetchDocumentCategories,
} from 'redux/modules/documentCategories';

const styles = theme => ({
  grid: {
    [theme.breakpoints.down('xs')]: {
      position: 'relative',
      '& + &': {
        marginTop: 24,
        borderTop: `1px solid ${theme.palette.grey[300]}`,
      },
    },
  },
  buttonRemove: {
    margin: '-5px -10px -5px -20px',
  },
  iconCross: {
    width: 15,
    height: 15,
  },
  gridItemRemove: {
    [theme.breakpoints.down('xs')]: {
      position: 'absolute',
      right: 0,
      top: 0,
      zIndex: 1,
    },
  },
});

const DocumentsCreateFieldArray = ({ fields, array, submitting, actions, classes }) => (
  fields.map((field, index) => (
    <Grid
      // eslint-disable-next-line react/no-array-index-key
      key={index}
      className={classes.grid}
      container
      spacing={24}
    >
      <Grid
        item
        sm={6}
        xs={11}
      >
        <Field
          id={`${field}.Document`}
          name={`${field}.Document`}
          component={UploadField}
          fullWidth
          loading={submitting}
          uploaded
        />
      </Grid>
      <Grid
        item
        sm={5}
        xs={12}
      >
        <Fields
          names={[
            `${field}.Document Category Name`,
            `${field}.Document Category`,
          ]}
          autosuggestFieldName={`${field}.Document Category Name`}
          fieldArrayName={`${field}.Document Category`}
          placeholder="-Select Category-"
          component={MultiselectAutosuggestField}
          renderSuggestionContent={suggestion =>
            suggestion.Name}
          renderInputContent={suggestion =>
            suggestion.Name}
          onSuggestionSelected={(suggestion) => {
            array.push(`${field}.Document Category`, {
              value: suggestion.ID,
              label: suggestion.Name,
            });
            return '';
          }}
          fetchSuggestions={({ value, limit, offset, fieldArrayValue }) => (
            value.length > 0 || (fieldArrayValue && fieldArrayValue.length > 0)
              ? requestSearchDocumentCategories({
                filters: [
                  ...value.length > 0
                    ? [{
                      name: 'Name',
                      operation: 'startswith',
                      val: value,
                      case_sensitivity: false,
                    }] : [],
                  ...fieldArrayValue && fieldArrayValue.length > 0
                    ? fieldArrayValue.map(arrayItem => ({
                      name: 'ID',
                      operation: 'ne',
                      val: arrayItem.value,
                    }))
                    : [],
                ],
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
              : requestFetchDocumentCategories({
                limit,
                offset,
              }).then(res => res.data,
                (err) => {
                  if (err.data.error === 'Need authorisation') {
                    actions.accountLoginFail();
                  }
                  return err;
                })
          )}
          keepOpenAfterSelection
        />
      </Grid>
      <Grid item className={classes.gridItemRemove}>
        <IconButton
          className={classes.buttonRemove}
          onClick={(event) => {
            event.stopPropagation();
            fields.remove(index);
          }}
          disabled={submitting}
          tooltipContent="Remove"
        >
          <IconCross className={classes.iconCross} />
        </IconButton>
      </Grid>
    </Grid>
  ))
);

DocumentsCreateFieldArray.propTypes = {
  submitting: PropTypes.bool.isRequired,
  fields: PropTypes.shape({
    remove: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    buttonRemove: PropTypes.string.isRequired,
    iconCross: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(DocumentsCreateFieldArray);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Documents/DocumentsCreateFieldArray.js